import { useEffect } from 'react';
import { useUser } from '../../components/UserContext';
import { useNavigate } from 'react-router-dom';
import { Loader } from '@sam/components';
import { useAuth } from 'react-oidc-context';

const TimeKeepingTrigger = () => {
  const { isAuthenticated, signinRedirect } = useAuth();
  const navigate = useNavigate();
  const { user } = useUser();

  //UseEffect to check if a user is logged in and redirects him directly
  //or after the login to start/end a timeTracking
  useEffect(() => {
    if (!user && !isAuthenticated)
      signinRedirect().then(() => navigate('/timekeeping', { state: { autostart: true } }));
    else navigate('/timekeeping', { state: { autostart: true } });
  }, [user, isAuthenticated, navigate]);

  return <Loader fullscreen />;
};
export default TimeKeepingTrigger;
